
import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { getSettingsFailure, getSettingsStart, getSettingsSuccess, updateSettingsFailure, updateSettingsStart, updateSettingsSuccess } from './SettingActions';

const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getSettings = async (dispatch) => {
    dispatch(getSettingsStart());
    try {
        const res = await axiosInstance.get(`/admin/settings/basics`, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getSettingsSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getSettingsFailure(err.response.data.message))
        } else {
            dispatch(getSettingsFailure("Unkown Error"))
        }
    }
}

export const updateSettings = async (dispatch, fullName, address, telephone, rc, nif, nis, ai, capital) => {
    dispatch(updateSettingsStart());
    try {
        const res = await axiosInstance.post(`/admin/settings/update`, {fullName, address, telephone, rc, nif, nis, ai, capital}, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateSettingsSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(updateSettingsFailure(err.response.data.message))
        } else {
            dispatch(updateSettingsFailure("Unkown Error"))
        }
    }
}